import { useEffect } from 'react';

interface PageMetaOptions {
  title: string;
  description: string;
  canonicalPath?: string;
}

const DEFAULT_TITLE = 'TEMPO | Padel & Pickleball Club in Houston, Texas';
const DEFAULT_DESCRIPTION = 'Join Tempo, the premier Padel and Pickleball Club in Houston, Texas. 5 outdoor padel courts, 4 pickleball courts, sauna, ice bath, bar & lounge. Book courts, memberships, and free intro lessons.';
const BASE_URL = 'https://tempo.club';

export function usePageMeta({ title, description, canonicalPath }: PageMetaOptions) {
  useEffect(() => {
    document.title = title;

    const meta = document.querySelector('meta[name="description"]') as HTMLMetaElement | null;
    if (meta) meta.content = description;

    const ogTitle = document.querySelector('meta[property="og:title"]') as HTMLMetaElement | null;
    if (ogTitle) ogTitle.content = title;

    const ogDesc = document.querySelector('meta[property="og:description"]') as HTMLMetaElement | null;
    if (ogDesc) ogDesc.content = description;

    const ogUrl = document.querySelector('meta[property="og:url"]') as HTMLMetaElement | null;
    if (ogUrl) ogUrl.content = `${BASE_URL}${canonicalPath || '/'}`;

    const twitterTitle = document.querySelector('meta[name="twitter:title"]') as HTMLMetaElement | null;
    if (twitterTitle) twitterTitle.content = title;

    const twitterDesc = document.querySelector('meta[name="twitter:description"]') as HTMLMetaElement | null;
    if (twitterDesc) twitterDesc.content = description;

    const canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (canonical && canonicalPath) canonical.href = `${BASE_URL}${canonicalPath}`;

    return () => {
      document.title = DEFAULT_TITLE;
      if (meta) meta.content = DEFAULT_DESCRIPTION;
      if (ogTitle) ogTitle.content = DEFAULT_TITLE;
      if (ogDesc) ogDesc.content = DEFAULT_DESCRIPTION;
      if (ogUrl) ogUrl.content = BASE_URL;
      if (twitterTitle) twitterTitle.content = DEFAULT_TITLE;
      if (twitterDesc) twitterDesc.content = DEFAULT_DESCRIPTION;
      if (canonical) canonical.href = `${BASE_URL}/`;
    };
  }, [title, description, canonicalPath]);
}
